import SegmentWrapper from './SegmentWrapper';

export default SegmentWrapper;
